import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { dataUser } from '../Helpers/util';
import axios from 'axios';
import SwInput from '../Common/FormComponent/SwInput';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwButton from '../Common/SwButtons/SwButtons';
import SwIconButton from '../Common/SwIconButton/SwIconButton';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

var FormData = require('form-data');

class MainHeadingFilterRole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj ? UserObj.company_id : null,
      pgno: this.props.filterPg,
      row: this.props.filterRow,
      status: '',
      order: '',
      searchText: '',
      showAddRoleFilter: false,
    };
  }
  changeSelect = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  reload = e => {
    window.location.reload();
  };

  submitFilter = e => {
    e.preventDefault();

    setTimeout(() => {
      this.RoleMember();
    }, 100);
    this.setState({ showAddRoleFilter: false });
  };

  handelChangeVal = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  RoleMember() {
    let authToken = JSON.parse(localStorage.getItem('headData'));
    axios
      .get(
        `${process.env.REACT_APP_API_URL
        }userRoles/getAllRolesByOrg?company_id=${this.state.company_id}&pgno=${this.state.pgno
        }&row=${this.state.row}&text=${this.state.searchText}&type=${this.state.status
        }&sort_by=${this.state.order}`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(response => {
        if (response.data && response.data.status == 'success') {
          this.props.FilterData(response.data.data);
        }
      })
      .catch(err => {
        console.log('Error: ' + err);
      });
  }
  componentWillReceiveProps() {
    this.setState({
      pgno: this.props.filterPg,
      row: this.props.filterRow,
    });
  }

  StatusMethod = status => {
    this.setState({ status: status.value });
  };

  render() {
    const ticketStatus = [
      {
        value: 'active',
        label: 'Active',
      },
      {
        value: 'inactive',
        label: 'In-Active',
      },
    ];

    return (
      <>
        <SwOffCanvas
          show={this.state.showAddRoleFilter}
          onClose={() => this.setState({ showAddRoleFilter: false })}
          title="Filters"
          placement="end"
          backdrop="static"
          keyboard={false}
          footer={
            <div className="OffCanvasFooter_Btns">
              <SwButton variant="dark-outline" onClick={this.reload}>
                Reload
              </SwButton>

              <SwButton
                variant="primary"
                className="ml10"
                onClick={this.submitFilter}
              >
                Apply
              </SwButton>
            </div>
          }
        >
          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Role Name</label>
                <SwInput
                  type="text"
                  name="searchText"
                  value={this.state.searchText}
                  onChange={this.handelChangeVal}
                  placeholder="Enter Role Name"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Status</label>
                <SwSelect
                  name="status"
                  options={ticketStatus}
                  value={
                    ticketStatus.find(opt => opt.value === this.state.status) ||
                    null
                  }
                  onChange={this.StatusMethod}
                  placeholder="Select Status"
                  isClearable={false}
                />
              </div>
            </div>
          </div>
        </SwOffCanvas>


        <SwIconButton size='sm'
          onClick={() => this.setState({ showAddRoleFilter: true })}
        >
          <i className="bi bi-funnel" />
        </SwIconButton>
      </>
    );
  }
}

export default connect()(MainHeadingFilterRole);
